import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-navs-example',
  templateUrl: './navs.component.html',
})
export class KitBootstrapNavsExampleComponent {}
